<template>
  <div v-show="notShowList.indexOf(currentPage) === -1"
    class="voice-button-container"
    @click="handleVoiceToggle()"
  >
    <div :class="{
      'text-button-wrapper': true,
      'text-button-shrink': fullToggleFlag
      }"
    >
      <div :class="{
        'text-wrapper': true,
        'fade-in': !fullToggleFlag,
        }"
      >
        Sound on
      </div>
    </div>
    <div class="image-wrapper">
      <img v-if="!volumnFlag" width="75%" height="95%" :src="require('../assets/images/turnoff.svg')" alt="">
      <img v-if="volumnFlag && canPlayFlag" width="100%" height="100%" :src="require('../assets/images/turnon.svg')" alt="">
      <div v-show="volumnFlag && !canPlayFlag" class="loader"></div>
    </div>
    <audio
      :src="audioSrc[currentPage] ? audioSrc[currentPage] : null"
      preload="auto"
      ref="audioRef"
    />
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils';

export default {
  name: 'VoiceButton',
  props: {
    currentPage: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      audioSrc: {
        1: require('../assets/speaches/921_sound_1.mp3'),
        3: require('../assets/speaches/921_sound_2.mp3'),
        4: require('../assets/speaches/921_sound_3.mp3'),
        5: require('../assets/speaches/921_sound_4.mp3'),
        6: require('../assets/speaches/921_sound_5.mp3'),
        7: require('../assets/speaches/921_sound_6.mp3'),
        8: require('../assets/speaches/921_sound_7.mp3'),
        9: require('../assets/speaches/921_sound_8.mp3'),
        10: require('../assets/speaches/921_sound_9.mp3'),
        11: require('../assets/speaches/921_sound_10.mp3'),
        12: require('../assets/speaches/921_sound_11_0916new.mp3'),
        13: require('../assets/speaches/921_sound_12.mp3'),
        14: require('../assets/speaches/921_sound_13.mp3'),
      },
      volumnFlag: false,
      firstTimeFlag: true,
      canPlayFlag: false,
      notShowList: [0, 2, 14],
      sectionIndex: {
        1: {
          start: 3.5,
          end: 23,
        },
        3: {
          start: 2.8,
          end: 18,
        },
        4: {
          start: 2.5,
          end: 7,
        },
        5: {
          start: 2.8,
          end: 28,
        },
        6: {
          start: 2.5,
          end: 16,
        },
        7: {
          start: 2.8,
          end: 32,
        },
        8: {
          start: 2.5,
          end: 14,
        },
        9: {
          start: 2.8,
          end: 13,
        },
        10: {
          start: 2.5,
          end: 16,
        },
        11: {
          start: 2.8,
          end: 26,
        },
        12: {
          start: 2.8,
          end: 27,
        },
        13: {
          start: 2.5,
          end: 19.5,
        },
        14: {
          start: 2,
          end: 7.5,
        },
      }
    };
  },
  watch: {
    currentPage: {
      handler(page) {
        this.canPlayFlag = false;
        if (this.sectionIndex[this.currentPage]) {
          this.$refs.audioRef.addEventListener('loadedmetadata', () => {
            if (this.volumnFlag) {
              let playPromise = this.$refs.audioRef.play();
              if (playPromise !== undefined) {
                playPromise.then(() => {
                  this.$refs.audioRef.currentTime = this.sectionIndex[this.currentPage].start;
                }).catch((error) => {
                  // alert(error);
                });
              }
            }
          }, false);
        }
      },
      deep: true,
    },
  },
  computed: {
    fullToggleFlag() {
      return this.currentPage === 1 && !this.volumnFlag ? false : true;
    },
  },
  methods: {
    handleVoiceToggle() {
      if (!this.volumnFlag) {
        setTimeout(() => {
          this.$refs.audioRef.play();
        }, 50);
      } else {
        this.$refs.audioRef.pause();
      }
      this.sendGA(this.volumnFlag ? 'Voice(off)' : 'Voice(on)');
      this.volumnFlag = !this.volumnFlag;
    },
    sendGA(voice) {
      window.ga("newmedia.send", {
        "hitType": "event",
        "eventCategory": "button",
        "eventAction": "click",
        "eventLabel": "[" + Utils.detectPlatform() + "][" + document.querySelector('title').innerHTML + "][" + voice +"]"
      });
    },
  },
  mounted() {
    this.$refs.audioRef.addEventListener('canplaythrough', (e) => {
      if (this.sectionIndex[this.currentPage]) {
        if (!this.canPlayFlag) {
          e.target.currentTime = this.sectionIndex[this.currentPage].start;
        }
        this.canPlayFlag = true;
      }
    }, false);
    this.$refs.audioRef.preload = "auto";
    this.$refs.audioRef.ontimeupdate  = (e) => {
      if (this.currentPage === 0 || this.currentPage === 2) {
        this.$refs.audioRef.pause();
      } else {
        if (e.target.currentTime >= this.sectionIndex[this.currentPage].end) {
          this.$refs.audioRef.pause();
        }
      }
    };
  },
};
</script>

<style lang="scss" scoped>
  .voice-button-container {
    position: fixed;
    z-index: 5002;
    right: 15px;
    bottom: 9%;
    display: flex;
    justify-content: center;
    align-items: center;
    @media only screen and (min-width: 769px) {
      right: 25px;
    }
    cursor: pointer;
    .text-button-wrapper {
      position: absolute;
      top: 0;
      right: 50px;
      width: 85px;
      height: 30px;
      border-radius: 50px;
      background-color: #57b09f;
      opacity: 1;
      transition: .333s ease-in-out;
      .text-wrapper {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        color: white;
        opacity: 0;
      }
      .fade-in {
        animation-name: fadeInAnimation;
        animation-duration: .333s;
        animation-timing-function: ease-in-out;
        animation-fill-mode: forwards;
        @keyframes fadeInAnimation {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      }
    }
    .text-button-shrink {
      top: -11px;
      right: 0px;
      width: 50px;
      height: 50px;
      opacity: 0.76;
      background-color: #ffffff;
      margin-left: 10px;
    }    
    .image-wrapper {
      position: relative;
      display: inline-block;
      height: 30px;
      width: 30px;
      margin: 0 10px;
      .loader {
        border: 4px solid #f3f3f3; /* Light grey */
        border-top: 4px solid #17d7f9; /* Blue */
        border-radius: 50%;
        width: 30px;
        height: 30px;
        animation: spin 1s linear infinite;
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      }
    }
  }
</style>
